<template>
  <div class="side-bars">
    <user-info class="user-info"></user-info>

    <div class="btn-wrap">
      <event tag="button" @click="clickSideBar(i)" class="button t_btn-d side-btn" v-for="(i, index) in btn"
             :key="index + 'btn'">
        <i :class="'img' + i.img" class="icon icon-btn"></i>
        <span>{{i.text}}</span>
      </event>
    </div>

    <div class="link-wrap">
      <event class="link"></event>
      <div class="link-box t_btn-h-bc">
        <ul class="list t_btn-h-bc clearBoth">
          <li class="tc-b_h" v-for="(tab, inde) in headTabs" :key="'ta'+inde" @click="open(tab)">{{tab.top + tab.b}}
          </li>
        </ul>
      </div>
    </div>
    
    <ul class="current-list">
      <h3 class="fb tc">最新注单</h3>
      <li class="current-item" v-for="(item,index) in lottery_list" :key="index">
        <h3 class="item-title">
          <span class="name">{{item.lottery_name}}</span>
          <span class="money tc">{{item.money}}</span>
        </h3>
        <p class="item-content">
          {{item.class2}},
          {{item.class3}},
          {{item.odds}}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from "vuex";
  import UserInfo from '../user-info';
  import {getNewLotteryRes} from '../../../service/lottery';

  export default {
    name: "index",
    components: {
      UserInfo
    },
    watch: {
      tabsLen: {
        handler() {
          this.tabMap = this.headTabs || [];
        },
        immediate: true
      },
      $route: {
        handler(route) {
          this.route = route.path;
        },
        immediate: true
      }
    },
    computed: {
      ...mapState('home', [
        'lottery_list'
      ]),
      ...mapGetters('home', [
        'headTabs'
      ]),
      head() {
        return this.headTabs.find(item => item.lottery_type == this.$route.query.lottery_type) || {};
      },
      tabsLen() {
        return this.headTabs.length;
      }
    },
    data() {
      return {
        btn: [
          {
            value: 0,
            img: 0,
            text: '未结明细'
          },
          {
            value: 1,
            img: 1,
            text: '今日已结'
          },
          {
            value: 2,
            img: 2,
            text: '历史报表'
          },
          {
            value: 3,
            img: 3,
            text: '个人信息'
          },
          {
            value: 4,
            img: 4,
            text: '修改密码'
          },
          {
            value: 5,
            img: 5,
            icon: require('./images/log-n.png'),
            text: '资金明细'
          },
          {
            value: 6,
            img: 0,
            text: '开奖结果'
          },
          {
            value: 7,
            img: 2,
            text: '玩法规则'
          }
        ]
      }
    },
    methods: {
      ...mapActions("root", ["logout"]),
      ...mapActions("home", ["setHeadTabs"]),
      open(option) {
          if(option.url!="")
          {
            window.open(option.url)
          }
          else
          {
            this.$router.push(option.path);
          }
      },
      async clickSideBar(i) {
        if(i.value==1 || i.value==2){
          let sub_category_id=1;
          let lottery_type=this.$route.query.lottery_type || 1;
          const info = await getNewLotteryRes({sub_category_id,lottery_type});
          if (info.result === "ok" && info.data.next_info.block_time==0) {
            alert(info.data.next_info.period + "期尚未结算，请稍候再查看");
            return
          }
        }
  
        switch (i.value) {
          // 未结明细
          case 0:
            this.$MessageBox.show('d14', {
              title: '未结明细'
            });
            break;

          //  今日已结
          case 1:
            this.$MessageBox.show('d15', {
              title: '今日已结'
            });
            break;

          //  历史报表
          case 2:
            this.$MessageBox.show('d16', {
              title: '历史报表'
            });
            break;

          //  个人信息
          case 3:
            this.$MessageBox.show('d23', {
              title: '个人信息'
            });
            break;

          //  修改密码
          case 4:
            this.$MessageBox.show('d24', {
              title: '修改密码'
            });
            break;

          //资金明细
          case 5:
            this.$MessageBox.show('d22', {
              title: '资金明细'
            });
            break;
          // 结果
        case 6:
          this.$MessageBox.show('d21', {
            title: '开奖结果-' + this.head.title,
            lottery_type: this.$route.query.lottery_type || 1,
            category_id: this.head.category
          });
          break;
        // 玩法规则
        case 7:
          this.$MessageBox.show('d13', {
            title: '游戏规则-' + this.head.title,
            lottery_type: this.$route.query.lottery_type || 1,
            category_id: this.head.category
          });
          break;
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  @import "../../../styles/variable"
  .side-bars
    width $side-bar-width
    font-size 14px

    > .user-info
      width 100%
      background-color #ffffff

    > .btn-wrap
      width 100%
      font-size 14px
      margin-top 3px
      font-weight bold

      &:after
        clear both
        content ""
        display block

      > .button
        float left
        width 104px
        height 45px
        margin-top 1px

        > .icon {
          width 24px
          height 24px
          display inline-block
          margin-right 2px
          background-size contain
          background-repeat no-repeat
          background-position center center
        }

      > .button:nth-of-type(even)
        float right
    
    > .link-wrap
      position relative

      &:hover > .link-box
        display block

      > .link
        width 210px
        height 60px
        margin-top 5px
        background url("./images/link-banner.png") no-repeat center center
        background-size contain

      > .link-box
        top 0
        right -265px
        width 270px
        font-size 12px
        z-index 10
        display none
        position absolute
        box-sizing border-box
        padding-left 15px

        &:before, &:after {
          top 25px
          z-index 11
          content ""
          display block
          position absolute
          border-style solid
          border-color transparent
          border-width 6px
        }

        &:before {
          left 3px
          border-right-color inherit
        }

        &:after {
          left 4px
          border-right-color white
        }

        > .list
          position relative
          box-sizing border-box
          border-width 1px
          border-style solid
          border-radius 4px
          background-color #ffffff;

          > li
            width 50%
            float left
            height 60px
            cursor pointer
            text-align center
            line-height 60px
            
          > li + li
            box-sizing border-box
            border-top 1px solid #e0e0e0

          > li:nth-of-type(2)
            border-top none
    
    > .current-list
      width 100%
      padding 4px 15px 2px 15px
      box-sizing border-box
      margin-top 5px
      border-radius 2px
      min-height 490px
      overflow auto
      background-color #ffffff
      > h3
        height 27px
        text-align center
        line-height 29px
        border-bottom 1px solid $border-color

      > .current-item + .current-item
        border-top 1px solid #e6e6e6

      > .current-item
        padding 5px 0 2px 2px
        box-sizing border-box

        > .item-title
          position relative
          text-align left
          padding-right 60px

          &:before
            top 50%
            left -11px
            width 2px
            height 2px
            content ""
            display block
            position absolute
            margin-top -1px
            border-radius 50%
            background-color #666

          .name
            overflow hidden
            white-space nowrap
            font-weight bold
            text-overflow ellipsis

          .money {
            top 50%
            right 0
            position absolute
            transform translateY(-50%)
          }

        .item-content
          color $color-default-1
          overflow hidden
          text-align left
          margin-top 3px
          white-space nowrap
          line-height 1
          text-overflow ellipsis


  .side-btn
    background: linear-gradient(0deg, rgba(218, 220, 224, 1), rgba(240, 244, 249, 1)) !important;

    .img0 {
      background-image: url("./images/book-n.png")
    }

    .img1 {
      background-image: url("./images/today-n.png")
    }

    .img2 {
      background-image: url("./images/history-n.png")
    }

    .img3 {
      background-image: url("./images/user-n.png")
    }

    .img4 {
      background-image: url("./images/pwd-n.png")
    }

    .img5 {
      background-image: url("./images/log-n.png")
    }

  .side-btn:hover
    .img0 {
      background-image: url("./images/book-s.png")
    }

    .img1 {
      background-image: url("./images/today-s.png")
    }

    .img2 {
      background-image: url("./images/history-s.png")
    }

    .img3 {
      background-image: url("./images/user-s.png")
    }

    .img4 {
      background-image: url("./images/pwd-s.png")
    }

    .img5 {
      background-image: url("./images/log-s.png")
    }
  .theme-1 .side-bars > .current-list{
      //background linear-gradient(#ff9e33, #b799a6) !important
      }
  .theme-2 .side-bars > .current-list{
      //background linear-gradient(#22ae27, #28571e) !important
      }
  .theme-3 .side-bars > .current-list{
      //background linear-gradient(#ba78f4, #350d40) !important
      }
.fb{font-weight:bold;}
@media screen and (max-width: 600px) {
  .side-bars{width:35vw !important} 
  .user-info{padding:0px !important;font-size:11px !important}
  .button{width:17vw !important;height: unset !important;}
  .button .icon{width:5vw !important}
  .link{width:35vw !important}
  .side-bars .current-item{padding:0px !important}
  .side-bars .current-list{padding:0px !important} 
}
</style>



// WEBPACK FOOTER //
// src/components/common/sideBars/index.vue